/**
 * Utility to track uploaded files across the app
 * Ensures files uploaded anywhere are tracked and categorized in the Data section
 */

export const trackUploadedFile = (file, dataType, metadata = {}) => {
  try {
    const fileData = {
      fileName: file.name || file.fileName,
      name: file.name || file.fileName,
      dataType: dataType, // 'booking' or 'label'
      type: dataType,
      fileSize: file.size || file.fileSize,
      size: file.size || file.fileSize,
      fileType: file.type || file.fileType || (file.name ? file.name.split('.').pop() : 'unknown'),
      uploadDate: new Date().toISOString(),
      fileId: metadata.fileId || `file_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      status: metadata.status || 'uploaded',
      source: metadata.source || 'manual', // 'manual', 'bulk-import', 'data-upload', etc.
      ...metadata
    };

    // Store in localStorage
    const storedFiles = localStorage.getItem('uploadedDataFiles');
    const files = storedFiles ? JSON.parse(storedFiles) : [];
    
    // Check if file already exists (by name and date to avoid duplicates)
    const existingIndex = files.findIndex(f => 
      f.fileName === fileData.fileName && 
      Math.abs(new Date(f.uploadDate) - new Date(fileData.uploadDate)) < 1000
    );
    
    if (existingIndex >= 0) {
      // Update existing file
      files[existingIndex] = { ...files[existingIndex], ...fileData };
    } else {
      // Add new file
      files.push(fileData);
    }
    
    localStorage.setItem('uploadedDataFiles', JSON.stringify(files));
    
    // Also try to save to backend if API is available
    try {
      const token = JSON.parse(localStorage.getItem('dizeeToken'));
      if (token) {
        // This will be handled by the upload API if available
        // For now, we just store locally
      }
    } catch (e) {
      console.warn('Could not save file to backend:', e);
    }
    
    return fileData;
  } catch (error) {
    console.error('Error tracking uploaded file:', error);
    return null;
  }
};

export const getUploadedFiles = (dataType = null) => {
  try {
    const storedFiles = localStorage.getItem('uploadedDataFiles');
    if (!storedFiles) return [];
    
    const files = JSON.parse(storedFiles);
    if (!dataType) return files;
    
    return files.filter(f => f.dataType === dataType || f.type === dataType);
  } catch (error) {
    console.error('Error getting uploaded files:', error);
    return [];
  }
};

export const getUploadedFilesCount = (dataType = null) => {
  const files = getUploadedFiles(dataType);
  return files.length;
};

